<router-outlet></router-outlet>

<div class="page-content">
  <header class="page-header">
    <div class="primary">
      <h1>Relatórios da Roleta Inteligente</h1>
      <p>Monitore o desempenho das filas de distribuição, gere relatórios e crie novas filas sempre que precisar.</p>
    </div>
    
    <div class="secondary">
      <button class="btn-white custom-btn" [routerLink]="'/fila-de-distribuicao'">     
        <span>Ir para Gerenciamento de Filas</span>
      </button>
      <div class="actions-menu">

        <mat-form-field class="select-filter-action" appearance="outline" *ngIf="isUserAdministrator()" >
          <input type="text"
            placeholder="Escolha a loja que deseja ver..."
            aria-label="name"
            matInput
            [formControl]="action"
            [matAutocomplete]="auto"
            (keyup.enter)="selectAction()">

          <mat-icon matSuffix class="icon-hand">keyboard_arrow_down</mat-icon>
          <mat-autocomplete  #auto="matAutocomplete" >
            <mat-option *ngFor="let item of companyListFiltered | async" (click)="selectAction()" [value]="item">
              {{item.company_name}}</mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <div class="period-btn">
          <div class="btn-actions">
      
            <button mat-stroked-button class="custom-date-range" [matMenuTriggerFor]="menu">
              <mat-icon>date_range</mat-icon>
              {{ label }}
            </button>

            <mat-menu #menu="matMenu">
              <button mat-menu-item *ngFor="let item of periodDateList" (click)="selectChange(item)"
                style="width: 195px;">{{item.label}}</button>
            </mat-menu>
            
          </div>
      
          <div class="period" *ngIf="isCustom">
            <nz-range-picker class="datepicker-range-filter-action" [(ngModel)]="date" (ngModelChange)="dateChange($event)"
              [nzFormat]="'dd MMM yyyy'">
            </nz-range-picker>
          </div>
        </div>

      </div>
    </div>
  </header>

  <div class="actions">
    <div class="navigation"></div>
    <div class="date-selector"></div>
  </div>

  <div class="container">
    <app-overview 
      [events]="eventsSubject.asObservable()" [companyEvents]="eventSubjectCompany.asObservable()">
    </app-overview>
    <app-leads-by-product 
      [events]="eventsSubject.asObservable()" [companyEvents]="eventSubjectCompany.asObservable()">
    </app-leads-by-product>
    <app-received-lead-by-agents 
      [events]="eventsSubject.asObservable()" [companyEvents]="eventSubjectCompany.asObservable()">
    </app-received-lead-by-agents>
  </div>

  <div class="breadcrumbs">
    <a (click)="back()">Voltar</a>
    <span>Relatórios da Roleta Inteligente</span>
  </div>

</div>